// Libraries
import moment from 'moment-timezone';
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeActionBased/types';
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';

// Constants
import { TRIGGER_TIME_LABEL } from 'Components/flowChart/components/NodePreview/components/NodeActionBased/constants';
import { FORMAT_FULL_DATE } from 'Components/flowChart/components/NodePreview/constants';

// Utils
import { getObjectPropSafely } from 'Utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeActionBased/index.tsx';

export interface INodeActionBased extends INodePreviewProps<IMetadata> {}

const NodeActionBased: React.FC<INodeActionBased> = (props) => {
	try {
		const {
			node: { metadata },
			timezone,
			lookupData,
		} = props;
		const { event, triggerType, startTime, endTime } = metadata;
		const startDate = startTime ? moment(startTime).tz(timezone).format(FORMAT_FULL_DATE) : null;
		const endDate = endTime ? moment(endTime).tz(timezone).format(FORMAT_FULL_DATE) : 'None';
		const eventName = getObjectPropSafely(
			() => lookupData!.events[event.eventTrackingName].eventNameDisplay,
			event.eventTrackingName
		);

		return (
			<>
				<CardBlock>
					<CardText>{eventName}</CardText>
				</CardBlock>
				<CardBlock>
					{startDate && (
						<>
							<CardText>Start date</CardText>
							<CardText icon="icon-antsomi-event">{startDate}</CardText>
						</>
					)}
					{endDate && (
						<>
							<CardText>Close date</CardText>
							<CardText icon="icon-antsomi-event">{endDate}</CardText>
						</>
					)}
				</CardBlock>
				<CardBlock>
					<CardText>{`Trigger time: ${TRIGGER_TIME_LABEL[triggerType]}`}</CardText>
				</CardBlock>
			</>
		);
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeScheduled',
			args: { props },
		});

		return null;
	}
};

export default NodeActionBased;
